import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    shipments: [],
    checkout_steps: [],
    state: 'complete',
    showDialogError: false,
    orderError: null,
};

const placedOrder = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.ADD_PLACED_ORDER:
        return { ...action.payload, state: 'complete' };
    case APP_ACTIONS.DESTROY_PLACED_ORDER:
        return { ...initialState };
    case APP_ACTIONS.ADD_ORDER_ERROR:
        return { ...state, orderError: action.payload };
    case APP_ACTIONS.COMPLETE_ORDER_ERROR:
        return { ...state, orderError: action.payload, showDialogError: true };
    case APP_ACTIONS.COMPLETE_ORDER_ERROR_HIDE_DIALOG:
        return { ...state, showDialogError: false };
    default:
        return state;
    }
};

export default placedOrder;



/** WEBPACK FOOTER **
 ** ./src/reducers/placed-order.js
 **/